import React, { useEffect, useRef, useState } from "react";
import httpRequest from "../../utils/Http";
import Select from "react-select";
import { isValidEmail, isValidMobile } from "../../utils/HelperFunction";
import { toast } from "react-toastify";

const AddUpdateEngineer = ({ formData, setFormData, setReload }) => {
  const [formErrors, setFormErrors] = useState({});
  const [applianceData, setApplianceData] = useState([]);
  const [allCallTypeGroup, setCallTypeGroup] = useState({});
  const [isSubmit, setSubmit] = useState(false);
  const closeRef = useRef();

  const setselecteddata = (val, item, index) => {
    const updatedFormData = formData.calltypeMapping; // Create a copy
    console.log(updatedFormData);

    if (!val || val.length === 0) {
      updatedFormData[index].calltype_group = [];
    } else {
      const isSelectAllClicked = val.some((opt) => opt.value === "select_all");

      if (isSelectAllClicked) {
        // Select all except "Select All"
        const allOptions = allCallTypeGroup.filter(
          (opt) => opt.value !== "select_all",
        );
        updatedFormData[index].calltype_group = allOptions;
      } else {
        updatedFormData[index].calltype_group = val;
      }
    }

    setFormData({
      ...formData,
      calltypeMapping: updatedFormData,
    }); // Update the state with new copy
  };

  useEffect(() => {
    (async () => {
      const listdata = await httpRequest(
        `getengineercalltypemaplist?engineer_id=${
          formData?.agent_id ? formData?.agent_id : ""
        }`,
        {},
        "GET",
      );
      if (listdata.status === true && listdata.data) {
        console.log(listdata.data);
        setApplianceData(listdata.data);
        setFormData({
          ...formData,
          calltypeMapping: listdata.data,
        });
      }

      const listdata2 = await httpRequest("getcalltypegrouplist", {}, "GET");
      if (listdata2.status === true && listdata2.data) {
        const callTypeList = listdata2.data?.rows;
        const options = [
          { label: "Select All", value: "select_all" },
          ...callTypeList.map((item) => ({
            label: item.label,
            value: item.value,
          })),
        ];
        setCallTypeGroup(options);
      }
    })();
  }, [formData?.agent_id]);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setSubmit(false);
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };

  const validateFrom = (value) => {
    const errors = {};
    if (!value.name) {
      errors.name = "Name is Required";
    }

    if (!value.email) {
      errors.email = "Email ID is Required";
    } else if (!isValidEmail(value.email)) {
      errors.email = "Enter Valid Email ID";
    }

    if (!value.mobile_number) {
      errors.mobile_number = "Mobile Number is Required";
    } else {
      if (!isValidMobile(value.mobile_number)) {
        errors.mobile_number = "Mobile Number is not valid";
      }
    }

    return errors;
  };

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        const data = await httpRequest("addupdateengineer", formData, "POST");
        setSubmit(false);
        if (data.status === true && data.message) {
          toast.success(data.message);
          closeRef.current.click();
          document.getElementById("createengineerlogin").reset();
          setFormData({});
          setReload(true);
        } else {
          toast.error(data.message);
        }
      }
    })();
    //eslint-disable-next-line
  }, [isSubmit, formErrors]);

  return (
    <div
      class="modal fade"
      id="modal-addengineer"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-addengineerlabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modal-addengineerlabel">
              Add Engineer
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={closeRef}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form
              className="form-horizontal"
              id="createengineerlogin"
              onSubmit={onSubmitHandler}
              action="javascritp:void(0)"
            >
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>
                          Name *{" "}
                          <span style={{ color: "red" }}>
                            {formErrors.name}
                          </span>
                        </label>
                        <div className="select2-purple">
                          <input
                            type="text"
                            defaultValue={formData.name}
                            className="form-control"
                            placeholder="Name"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                name: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      {/* /.form-group */}
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>
                          Mobile Number *{" "}
                          <span style={{ color: "red" }}>
                            {formErrors.mobile_number}
                          </span>
                        </label>
                        <div className="select2-purple">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Mobile Number"
                            defaultValue={formData.mobile_number}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                mobile_number: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      {/* /.form-group */}
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>
                          Email Address *{" "}
                          <span style={{ color: "red" }}>
                            {formErrors.email}
                          </span>
                        </label>
                        <div className="select2-purple">
                          <input
                            defaultValue={formData.email}
                            type="text"
                            className="form-control"
                            placeholder="Email Address"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                email: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      {/* /.form-group */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="row">
                    {applianceData.map((item, index) => (
                      <div key={"colsm-" + index} className="col-12 col-sm-6">
                        <div key={"formgroup-" + index} className="form-group">
                          <label key={"label-" + index}>
                            {item.appliance_name}
                          </label>
                          <input
                            type="hidden"
                            name="appliance_id"
                            value={item.appliance_id}
                          />
                          <Select
                            defaultValue={item.calltype_group}
                            key={index}
                            isMulti={true}
                            name="calltype_group_id"
                            options={allCallTypeGroup}
                            value={
                              formData?.calltypeMapping?.[index]?.calltype_group
                            }
                            onChange={(val) => {
                              setselecteddata(val, item, index);
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="card-footer">
                    <div className="row">
                      <input
                        type="submit"
                        className="form-control btn btn-primary"
                        value={"Submit"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUpdateEngineer;
